/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Load_FailedInputs */

const en_us2_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load this exercise.`)
};

const pt_br2_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar este exercício.`)
};

const es_419_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar este ejercicio.`)
};

const pt_pt2_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar este exercício.`)
};

const fr_fr2_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger cet exercice.`)
};

const de_de2_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung konnte nicht geladen werden.`)
};

const it_it2_exercise_load_failed = /** @type {(inputs: Exercise_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare questo esercizio.`)
};

/**
* | output |
* | --- |
* | "Couldn't load this exercise." |
*
* @param {Exercise_Load_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_load_failed = /** @type {((inputs?: Exercise_Load_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Load_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_load_failed(inputs)
	if (locale === "es-419") return es_419_exercise_load_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_load_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_load_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_load_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_load_failed(inputs)
	return en_us2_exercise_load_failed(inputs)
});
export { exercise_load_failed as "exercise.load_failed" }